import React from 'react';
import { useTranslation } from 'react-i18next';

import { PageRootWrapper } from '@/components/shared/PageRootWrapper';
import { RemindFormContainer } from '@/components/pages/PasswordReset/Start/RemindForm';
import { Message } from '@/components/pages/PasswordReset/Start/Message';

export const PasswordResetStartPage: React.FC = () => {
  const { t } = useTranslation();
  const title = t('pages.password.reset.start.title');

  return (
    <PageRootWrapper
      title={title}
      headerTitle={t('text.password.reset.start.prompt')}
      containerType="normal"
    >
      <Message />
      <RemindFormContainer />
    </PageRootWrapper>
  );
};
